import { useState } from 'react';

import { message } from 'antd';

import type { AirdropClaimHistory } from '@api/index';
import {
  fetchAirdropClaimHistory
} from '@api/index';
export const useClaimHistory = () => {
  const [claimHistoryData, setClaimHistory] = useState<AirdropClaimHistory>();
  const fetchClaimHistory = async () => {
    const data = await fetchAirdropClaimHistory();
    console.log('propsData', data);
    if (!data.success) {
      message.error(data.msgKey);
      return;
    }
    const receiveList = data.obj.receiveList;
    setClaimHistory({
      ...data.obj,
      receiveList
    });
  }
  return { claimHistoryData, fetchClaimHistory };
};
